import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import { getAuthToken } from './helper';

const ProtectedRoutes = () => {
    const token = getAuthToken()

    return token ? <Outlet /> : <Navigate to="/signin" replace />;

}

export default ProtectedRoutes
